module.exports = __webpack_public_path__ + "img/hearth.c8dcc090.png";